@use "../../../sass/global/global" as *;

.ux-iws-interactive-tile {
    position: relative;
    background: $smart-factory-tile-background-small;
    color: $color-white;
    flex: 1 1 0%;
    display: flex;
    transition:
        height $animationSpeed-normal $animationEasing-ease,
        background $animationSpeed-normal $animationEasing-ease,
        padding $animationSpeed-normal $animationEasing-ease;

    &:not(:last-child) {
        border-bottom: 1px solid $color-gray-borders;
    }

    @media only screen and (min-width: 1024px) {
        background: $smart-factory-tile-background;
    }

    &__content-wrapper {
        padding: 32px 30px;

        @media only screen and (min-width: 568px) {
            padding: 44px 60px 44px 30px;
        }

        @media only screen and (min-width: 1024px) {
            padding: 30px;
            display: block;
            align-self: flex-end;
            padding-top: 125px;
        }
    }

    &__content-wrapper--static {
        @media only screen and (min-width: 1024px) {
            align-self: flex-start;
            display: flex;
            flex-direction: column;
            align-self: stretch;
        }
    }

    &__content-wrapper::after {
        @media only screen and (min-width: 1024px) {
            content: "";
            position: absolute;
            z-index: auto;
            top: 0;
            right: -1px;
            display: block;
            content: "";
            height: 100%;
            width: 2px;
            background: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0) 0,
                rgba(255, 255, 255, 0.25) 100%
            );
        }
    }

    &__header {
        display: flex;
        align-items: center;
        margin-right: 50px;

        @media only screen and (min-width: 1024px) {
            flex-direction: column;
            align-items: flex-start;
            margin-right: 0;
        }
    }

    &__icon-container {
        margin-right: 15px;

        @media only screen and (min-width: 1024px) {
            margin-right: 0;
            margin-bottom: 25px;
        }
    }

    &__icon-container ux-icon {
        color: $color-white;
        font-size: 45px;

        @media only screen and (min-width: 1024px) {
            font-size: 65px;
        }
    }

    *[slot="headline"] {
        color: $color-white;
        font-size: 18px;
        line-height: 24px;

        @media only screen and (min-width: 768px) {
            font-size: 20px;
            line-height: 26px;
        }

        @media only screen and (min-width: 1024px) {
            font-size: 22px;
            line-height: 28px;
            width: 100%;
        }
    }

    *[slot="copy-text"] * {
        color: $color-white !important;
        font-size: $size-text-medium-plus !important;
        line-height: $line-height-medium !important;
    }

    *[slot="link"] {
        @media only screen and (min-width: 1024px) {
            margin-top: auto;
        }
    }

    a:hover {
        color: $color-white;

        ux-icon {
            color: $color-white;
        }
    }

    &__content {
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
    }

    &__content--interactive {
        height: 0;
        overflow: hidden;
        max-height: 1500px;
        transition: height $animationSpeed-fast $animationEasing-ease;

        @media (max-width: 1023px) {
            max-height: 1500px;
        }

        @media (max-width: 768px) {
            max-height: 2250px;
        }
    }

    &__up-arrow {
        display: block;
        position: absolute;
        top: 35px;
        right: 30px;

        @media only screen and (min-width: 1024px) {
            position: absolute;
            width: 100%;
            right: 0;
            top: auto;
            bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    &__number {
        font-size: 22px;

        @media only screen and (min-width: 768px) {
            font-size: 30px;
        }

        @media only screen and (min-width: 1024px) {
            font-size: 34px;
        }

        &--green {
            color: $color-green !important;
        }
    }

    &__number-container {
        width: 50px;
        min-width: 50px;
        height: 50px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        @media only screen and (min-width: 768px) {
            min-width: 65px;
            height: 65px;
        }

        @media only screen and (min-width: 1024px) {
            min-width: 75px;
            height: 75px;
            margin-bottom: 15px;
        }
    }

    &__number-circle {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__up-arrow ux-icon[name="arrow-down"],
    &__up-arrow ux-icon[name="chevron-down"] {
        color: $color-green;

        @media only screen and (min-width: 1024px) {
            transform: rotate(180deg);
        }
    }

    &--interactive {
        cursor: pointer;
    }

    &--active {
        background: $smart-factory-tile-background-small-active;
    }

    &--active *[slot="link"] a {
        color: $color-white;

        &:hover {
            color: $color-blue-highlight-1;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            ux-icon {
                color: $color-blue-highlight-1 !important;
            }
            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }
    }

    &--with-number .ux-iws-interactive-tile__content-wrapper {
        @media only screen and (min-width: 568px) {
            padding: 30px 60px 30px 30px;
        }

        @media only screen and (min-width: 1024px) {
            padding: 30px;
            padding-top: 125px;
        }
    }

    &__up-arrow {
        @media only screen and (max-width: 767px) {
            pointer-events: none;
        }
    }
}
